import type { Company } from "@somasi/shared";

/**
 * Company vocabulary, as the pages and the exports need it.
 *
 * These two maps lived in `routes/_authenticated/companies.tsx`, which was fine
 * while the only readers were other routes. It stopped being fine once the
 * client groups list needed a status label to write into the companies it
 * exports: `companies.tsx` already imports `ExportMenu` from
 * `client-groups.tsx`, so reading the labels back out of that route would have
 * closed a cycle between the two modules. The vocabulary is not the page's, so
 * it sits here and the route re-exports it for the call sites that already say
 * `from "./companies"`.
 */

/**
 * Most companies here are incorporated in the BVI, so that is the default — on
 * the new-company form and on an import row that leaves the column blank.
 *
 * Spelled as the seeded country list spells it, so a company saved either way
 * opens on a match in the jurisdiction picker rather than on a value flagged
 * "not in list". Companies saved earlier may hold "BVI"; the picker still
 * offers those, so nothing is lost on open.
 */
export const DEFAULT_JURISDICTION = "British Virgin Islands";

export const STATUS_LABEL: Record<Company["status"], string> = {
  active: "Active",
  dormant: "Dormant",
  struck_off: "Struck off",
  dissolved: "Dissolved",
  in_liquidation: "In liquidation",
  closed: "Closed",
};

export const STATUS_TONE: Record<Company["status"], string> = {
  active: "bg-success text-success-foreground",
  dormant: "bg-muted text-muted-foreground",
  struck_off: "bg-warning text-warning-foreground",
  dissolved: "bg-destructive text-destructive-foreground",
  in_liquidation: "bg-warning text-warning-foreground",
  closed: "bg-muted text-muted-foreground",
};
